/**
 * Copyright (c) Qwoach LLC 2026. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import ServiceItem from "@shared/Quote/ServiceItem";
import {ServiceUsageType} from "@shared/Invoice/ServiceUsageType";

export default class QuoteRateItem extends ServiceItem {

	rateType: string = null;
	isStandard: boolean = false;

	constructor(options = {}) {
		super({
			serviceUsageType: ServiceUsageType.RATE,
			hasQuantity: false,
			hasPrice: true,
			...options
		});
		this.applyOptions(options);
		if (!this.serviceUsageType) {
			this.serviceUsageType = ServiceUsageType.RATE;
		}
		this.hasQuantity = false;
		this.hasPrice = true;
	}

	migrateTitle(getCanonicalTitleFn = null) {
		if (!this.isStandard) {
			return
		}
		let currentTitle = getCanonicalTitleFn?.(this.rateType)
		if (!currentTitle) {
			return
		}
		this.title = currentTitle
	}
}
